import React from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { NoMatch } from '../pages/NoMatch';
import MainLayout from '../layouts/MainLayout';
import BusinessNavigatorPage from '../pages/BusinessNavigatorPage';
import MyBusinessChecklistPage from '../pages/MyBusinessChecklistPage';
import MyCompaniesPage from '../pages/MyCompanies';
import PrimeAccountServicesPage from '../pages/PrimeAccountServicesPage';
import BillingHistoryPage from '../pages/BillingHistoryPage';
import MailBoxPage from '../pages/MailBoxPage';
import LoginPage from '../pages/AuthPage/Login';
import EmailOtpPage from '../pages/AuthPage/EmailOtp';
import AuthLayout from '../layouts/AuthLayout';
import { Signout } from '../pages/Signout';
import AccountInfo from '../pages/AccountInfo';
import PaymentInfo from '../pages/PaymentInfo';
import LegalTemplates from '../pages/LegalTemplates';
import CustomerSupport from '../pages/CustomerSupport';
import ContactSales from '../pages/ContactSales';
import { LoginAsContact } from '../pages/LoginAsContact';
import PrimeAssessment from '../pages/PrimeAssessment';
import PrimeAssessmentList from '../pages/PrimeAssessmentList';
import TermsPage from '../pages/Terms';
import OnlineCart from '../pages/OnlineCart';
import { DEFAULT_ONLINE_CART_RECORD_ID } from '../pages/OnlineCart/constants';
import EstatePlanning from '../pages/EstatePlanning';
import BusinessCoachPage from '../pages/BusinessCoach';
import OrderUpdateLayout from '../layouts/OrderUpdateLayout';
import UpdateCustomerOrders from '../pages/UpdateCustomerOrders';
import { UPDATE_CUSTOMER_ORDERS_PATH } from '../pages/UpdateCustomerOrders/constants';


const A = ()=>(<div>hello</div>)
function Router() {
    const taxSurveyId = process.env.REACT_APP_TAX_SURVEY_ID;
    const isBusinessCoachEnabled = process.env.REACT_APP_ENABLE_BUSINESS_COACH === 'true';

    return (
        <Routes>
            {!window.location.hostname?.startsWith('tax.') && !window.location.hostname?.startsWith('checkout.') && !window.location.hostname?.startsWith('online-cart.') && (
                <Route
                    element={
                        <MainLayout>
                            <Outlet />
                        </MainLayout>
                    }
                >
                    <Route path="/" element={<PrimeAccountServicesPage />} />
                    <Route path="/my-business-checklist" element={<MyBusinessChecklistPage />} />
                    <Route path="/business-navigator" element={<BusinessNavigatorPage />} />
                    <Route path="/my-companies/:id" element={<MyCompaniesPage />} />

                    <Route path="/payment-information/billing-history" element={<BillingHistoryPage />} />
                    <Route path="/payment-information/payment-methods" element={<PaymentInfo />} />

                    <Route path="/mail" element={<MailBoxPage />} />
                    <Route path="/account-info" element={<AccountInfo />} />
                    <Route path="/customer-support" element={<CustomerSupport />} />
                    <Route path="/contact-sales" element={<ContactSales />} />
                    <Route path="/legal-templates" element={<LegalTemplates />} />
                    <Route path="/estate-planning/*" element={<EstatePlanning />} />

                    <Route path="/prime-assessment" element={<PrimeAssessment />} />
                    <Route path="/prime-assessment-list" element={<PrimeAssessmentList />} />
                    {isBusinessCoachEnabled && <Route path="/business-coach" element={<BusinessCoachPage />} />}
                </Route>
            )}

            {!window.location.hostname?.startsWith('checkout.') && !window.location.hostname?.startsWith('online-cart.') && (
                <Route
                    element={
                        <div style={{ display: 'inline' }}>
                            <Outlet />
                        </div>
                    }
                >
                    <Route
                        element={
                            <MainLayout withoutLayout={true}>
                                <Outlet />
                            </MainLayout>
                        }
                    >
                        {window.location.hostname?.startsWith('tax.') && (
                            <Route path="/" element={<Navigate to={taxSurveyId ? `/prime-assessment-page?surveyId=${taxSurveyId}` : '/prime-assessment-page'} replace />} />
                        )}
                        <Route path="/prime-assessment-page" element={<PrimeAssessment mode="public" withLogin={true} />} />
                    </Route>
                    <Route
                        element={
                            <AuthLayout>
                                <Outlet />
                            </AuthLayout>
                        }
                    >
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/email-otp" element={<EmailOtpPage />} />
                    </Route>

                    <Route
                        element={
                            <OrderUpdateLayout>
                                <Outlet />
                            </OrderUpdateLayout>
                        }
                    >
                        <Route path={UPDATE_CUSTOMER_ORDERS_PATH} element={<UpdateCustomerOrders />} />
                    </Route>

                    <Route path="/signout" element={<Signout />} />
                    <Route path="/terms" element={<TermsPage />} />

                    <Route path="/loginAsContact/:payload" element={<LoginAsContact />} />
                    <Route path="/prime-assessment-details" element={<PrimeAssessment mode="public" />} />
                </Route>
            )}
            {(window.location.hostname?.startsWith('checkout.') || window.location.hostname?.startsWith('online-cart.')) && (
                <Route
                    element={
                        <div style={{ display: 'inline' }}>
                            <Outlet />
                        </div>
                    }
                >
                    <Route path="/" element={<Navigate to={`/online-cart/${DEFAULT_ONLINE_CART_RECORD_ID}`} replace />} />
                    <Route path="/online-cart" element={<Navigate to={`/online-cart/${DEFAULT_ONLINE_CART_RECORD_ID}`} replace />} />
                    <Route path="/online-cart/:recordId" element={<OnlineCart />} />
                </Route>
            )}


            <Route path="*" element={<NoMatch />} />
        </Routes>
    );
}

export default Router;
